import React, { Fragment } from 'react'
import * as Headers from './header'
import * as Sidebars from './sidebar'
import * as GiftInfo from './gift-info'
import * as DonorInfo from './donor-info'
import * as PaymentInfo from './payment-info'
import { withRouter } from 'react-router-dom'
import { StripeProvider, Elements, injectStripe } from 'react-stripe-elements'
import { executePayment } from './paymentService'
import parseQuery from '../views/parser'
import propTypeSchema from 'react-json-schema-proptypes'
import { getStore } from '../common/store'
import { DONATE_RESET, DONATE_SUCCESS } from '../common/reducers/actions'
import { FacebookTrackingPixel } from '../views/conversion'
import queryString from 'query-string'
import database from '../common/database'
import userActions from '../common/actions/user.js'
import ReactGA from 'react-ga'
import NotFound from '../views/notFound.jsx'
import Radium, { StyleRoot } from 'radium'
import get from 'lodash/get'
import phone from "phone";
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { calculateAmountWithCharge, valueOrUndefined,  valueOrUndefinedBool, timeout } from './common'
import { Loader } from 'react-loaders'
import { Row, Col } from 'react-bootstrap'
import { ProcessingModal, FailModal } from './status-modals'
import ThankYou from './thank-you'
import * as Scroll from 'react-scroll/modules/index'
import { saveUrlParams } from '../common/utils.js'
import { Sidebar } from './types'
import {loadStripe} from '@stripe/stripe-js/pure';
import emailValidator from 'email-validator'
import { isEmpty, trim } from 'lodash'
import { addDonorToTrackingSegment, trackMmsLinkClick } from '../common/api'

const headerMapping = {
  alpha: Headers.Alpha,
  beta: Headers.Beta,
  delta: Headers.Delta,
  empty: null,
}

const sidebarMapping = {
  alpha: Sidebars.Alpha,
  beta: Sidebars.Beta,
  delta: Sidebars.Delta,
  empty: null,
}

const giftInfoMapping = {
  alpha: GiftInfo.Alpha,
  beta: GiftInfo.Beta
}

const donorInfoMapping = {
  alpha: DonorInfo.Alpha,
  beta: DonorInfo.Beta
}

const paymentInfoMapping = {
  alpha: PaymentInfo.Alpha,
  beta: PaymentInfo.Beta
}

export const schema = {
  'type': 'object',
  'required': ['campaignConfig'],
  'properties': {
    'campaignConfig': {
      'type': 'object',
      'properties': {
        'defaultAmountIndex': { 'type': 'number' },
        'successRedirect': { 'type': 'string' },
        'minRedirectAmount': { 'type': 'number' },
        'campaignName': { 'type': 'string' },
        'header': {
          'type': 'object',
          'oneOf': [Headers.Alpha.propSchema, Headers.Beta.propSchema, Headers.Delta.propSchema]
        },
        'giftInfo': {
          'type': 'object',
          'oneOf': [GiftInfo.Alpha.propSchema, GiftInfo.Beta.propSchema]
        },
        'donorInfo': {
          'type': 'object',
          'oneOf': [DonorInfo.Alpha.propSchema, DonorInfo.Beta.propSchema]
        },
        'paymentInfo': { 'type': 'object', 'oneOf': [PaymentInfo.Alpha.propSchema, PaymentInfo.Beta.propSchema] },
        'layout': {
          'type': 'object',
          'properties': {
            'sidebarSize': { 'type': 'number' },
            'sidebarStyle': Sidebar.Schema,
            'maxWidth': { 'type': 'number' },
          }
        }
      }
    }
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  config: state.config
})

const mapDispatchToProps = (dispatch) => {
  return {
    userActions: bindActionCreators(userActions, dispatch)
  }
}

const defaultLayout = {
  maxWidth: 900,
  sidebarStyle: {
    breakpoint: 768,
    border: "none",
    marginTop: "0"
  },
  sidebarSize: 3
}

@connect(mapStateToProps, mapDispatchToProps)
@Radium
class DonatePage extends React.PureComponent {
  static propTypes = propTypeSchema(schema, {
    'required': ['stripeKey'],
    'properties': {
      'enableGtm': { 'type': 'boolean' },
      'campaign': { 'type': 'string'},
      'stripeKey': { 'type': 'string' },
      'assetLoader': { 'isFunction': true }
    }
  })

  constructor(props) {
    super(props)
    this.state = {
      enteredPayment: false,
      donationAmount: undefined,
      address: {
        street: '',
        city: '',
        state: '',
        country: 'United States'
      },
      projects: [],
      selectedProject: undefined,
      projectMetadata: {},
      basicDonorInfo: {},
      assumeFee: true,
      saveInfo: false,
      displayErrors: false,
      savedCards: [],
      useExistingCard: null,
      recaptchaToken: null,

      giftValid: false,
      donorValid: false,
      paymentValid: false,
      firebaseToken: null,
      loaded: false,
      isProcessing: false,
      isFailed: false,
      isSuccess: false,
      extraFields: {},
      extraFieldsValues: {
        recipientCountry: 'United States'
      },
      extraFieldsDependencies: {},
      extraFieldsErrors: {},
      extraFieldsValuesDependencies: {},
      extraFieldsValuesOptionalDependencies: {},
    }
  }

  updateAmount = (newAmount) => {
    this.setState({
      donationAmount: newAmount
    })
  }

  updateProject = (newProject) => {
    this.setState({
      selectedProject: newProject
    })
  }

  updateProjectMetadata = (extraMetadata) => {
    this.setState({
      projectMetadata: {
        ...extraMetadata
      }
    })
  }

  updateDonorInfo = (donorInfo) => {
    this.setState(state => {
      return {
        basicDonorInfo: {
          ...state.basicDonorInfo,
          ...donorInfo
        }
      }
    })
  }


  defaultExtraFieldsValuesDependencies = (extraFieldsValuesDependencies, extraFields, extraFieldsValuesOptionalDependencies) => {
    this.setState({
      extraFieldsValuesDependencies,
      extraFieldsValuesOptionalDependencies,
      extraFields
    })
  }

  updateExtraFields = (extraField, dependencies) => {
    const fieldName = Object.keys(extraField)[0]
    this.setState(state => {
      return {
        extraFieldsValues: {
          ...state.extraFieldsValues,
          ...extraField
        },
        extraFieldsValuesDependencies: {
          ...state.extraFieldsValuesDependencies,
          [fieldName]: dependencies
        }
      }
    })
  }

  updateExtraFieldsDependencies = (extraFieldsDependencies, field) => {

    const { checkBoxLink, dependencies } = field
    let checkboxesOff = []
    const fieldName = Object.keys(extraFieldsDependencies)[0]

    //Turn off all checkboxes linked
    if (checkBoxLink) {
      checkBoxLink.forEach(function (name) {
        checkboxesOff[name] = false
      })
    }

    this.setState(state => {
      return {
        extraFieldsDependencies: {
          ...state.extraFieldsDependencies,
          ...checkboxesOff,
          ...extraFieldsDependencies
        },
        extraFieldsValuesDependencies: {
          ...state.extraFieldsValuesDependencies,
          [fieldName]: dependencies
        }
      }
    })
  }

  updateCard = (newCard) => {
    this.setState({
      useExistingCard: newCard
    })
  }

  updateAddress = (address) => {
    this.setState(state => {
      return {
        address: {
          ...state.address,
          ...address
        }
      }
    })
  }

  recaptchaChanged = (recaptchaToken) => {
    this.setState({
      recaptchaToken: recaptchaToken
    })
  }

  giftValidChanged = (valid) => {
    this.setState({
      giftValid: valid
    })
  }

  donorInfoValidationChanged = (valid) => {
    this.setState({
      donorValid: valid
    })
  }

  paymentValidChanged = (valid) => {
    if (!this.state.enteredPayment && valid) {
      this.setState({ enteredPayment: true }, () => {
        console.info('Sending event for payment info')
        ReactGA.plugin.execute('ec', 'addProduct', {
          id: this.state.isCustom ? 'donation-custom' : 'donation',
          name: 'Donation',
          price: this.state.amount ? this.state.amount.amount : 0,
          quantity: 1
        })
        ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
          'step': 2
        });
        ReactGA.event({ category: 'Checkout', action: 'Payment Entered' });
      })
    }
    this.setState({
      paymentValid: valid
    })
  }

  assumeFeeChanged = (assumeFee) => {
    this.setState({
      assumeFee: assumeFee
    })
  }

  saveInfoChanged = (saveInfo) => {
    this.setState({
      saveInfo: saveInfo
    })
  }

  allValid = () => {
    return this.state.giftValid && this.state.donorValid && this.state.paymentValid
  }

  closeFail = () => { this.setState({ isFailed: false }) }

  optionalDependenciesCompleted = (fieldName) => {
    const { extraFieldsValuesOptionalDependencies, extraFieldsDependencies } = this.state

    const optionals = extraFieldsValuesOptionalDependencies[fieldName]

    const optionalReducer = (accumulator, currentValue) => (accumulator
      || (Boolean(extraFieldsDependencies)
        && extraFieldsDependencies[currentValue]))

    const completed = (optionals && optionals.reduce(optionalReducer, false)) || !optionals

    return completed
  }


  prepareExtraData = () => {
    const {
      extraFieldsDependencies,
      extraFieldsValues,
      extraFieldsValuesDependencies,
      extraFields } = this.state
    let metadata = { ...this.state.projectMetadata }

    const optionalDependenciesCompleted = this.optionalDependenciesCompleted
    if (Object.keys(extraFields).length > 0) {
      let extraFieldsDependenciesMap = {}
      let extraFieldsValuesToSend = extraFieldsValues

      Object.keys(extraFieldsDependencies).forEach(function (key) {
        extraFieldsDependenciesMap[key] = extraFieldsDependencies[key] ? "yes" : "no";
      });

      Object.keys(extraFieldsValuesDependencies).forEach(function (fieldName) {
        const field = extraFields.find((f) => f.name == fieldName)
        const optionalsCompleted = optionalDependenciesCompleted(fieldName)

        if (!optionalsCompleted) {
          delete extraFieldsValuesToSend[fieldName]
          delete extraFieldsDependenciesMap[fieldName]
        }else if (extraFieldsValuesDependencies[fieldName]
          && extraFieldsValuesDependencies[fieldName].length > 0) {
          extraFieldsValuesDependencies[fieldName].forEach(function (dep) {
            if (!extraFieldsDependencies[dep]) {
              delete extraFieldsValuesToSend[fieldName]
              delete extraFieldsDependenciesMap[fieldName]
            }
          });
        }
        if (field.type === 'emailList' && extraFieldsValues[fieldName]) {
          extraFieldsValuesToSend[fieldName] = extraFieldsValues[fieldName]
            .filter((e) => emailValidator.validate(e))
            .join(';')
        }

      });

      this.setState({
        extraFieldsValues: extraFieldsValuesToSend
      })

      metadata = {
        ...metadata,
        ...extraFieldsValuesToSend,
        ...extraFieldsDependenciesMap
      }
    }

    return metadata
  }


  execDonation = async () => {
    if (!this.allValid()) {
      this.setState({
        displayErrors: true
      })
    } else {
      this.setState({
        isProcessing: true
      })
      const source = parseQuery.getQueryVariable('utm_source')
      const medium = parseQuery.getQueryVariable('utm_medium')
      const mot = parseQuery.getQueryVariable('mot')
      const QRCode = parseQuery.getQueryVariable('QRCode')
      const amount = { ...this.state.donationAmount }
      if (!amount.frequency) {
        amount.frequency = 'one-time'
      }
      if (this.state.assumeFee) {
        amount.amount = calculateAmountWithCharge(amount.amount)
      }
      let donateParams = {
          amount,
          saveInfo: this.state.saveInfo || (this.state.donationAmount && this.state.donationAmount.frequency === 'monthly'),
          source,
          medium,
          mot,
          QRCode,
          projectId: valueOrUndefined(this.state, 'selectedProject.id'),
          feesAssumed: valueOrUndefinedBool(this.state, 'assumeFee'),
          extraMetadata: this.prepareExtraData(),
          campaign: get(this.props.campaignConfig, 'campaignName', this.props.campaign)
      }

      if (!this.state.useExistingCard) {
        const token = await this.props.stripe.createToken({
          name: this.state.basicDonorInfo.firstName + ' ' + this.state.basicDonorInfo.lastName,
          address_line1: this.state.address.street,
          address_city: this.state.address.city,
          address_state: this.state.address.state,
          address_zip: this.state.address.zipCode,
          address_country: this.state.address.country
        })

        let normalizedPhone = phone(this.state.basicDonorInfo.mobileNumber)[0]

        donateParams = {
          ...donateParams,
          token: token.token.id,
          firstName: this.state.basicDonorInfo.firstName,
          lastName: this.state.basicDonorInfo.lastName,
          email: this.state.basicDonorInfo.email,
          phoneNumber: normalizedPhone ? normalizedPhone : null,
        }
      } else {
        donateParams = {
          ...donateParams,
          cardId: this.state.useExistingCard.id,
          customerId: this.state.useExistingCard.customerId,
          userToken: this.state.firebaseToken,
        }
      }

      //console.info("donateParams \n", donateParams)

      //Execute call to service
      try {
        const serviceResult = await executePayment(donateParams, this.state.recaptchaToken)
        if (serviceResult) {
          console.log('Donation went through')
          this.setState({
            isProcessing: false,
            isSuccess: true
          })
          getStore().dispatch({ type: DONATE_SUCCESS })
          if (this.props.campaignConfig.successRedirect && this.props.campaignConfig.minRedirectAmount <= this.state.donationAmount.amount) {
            window.location = this.props.campaignConfig.successRedirect
          }
        } else {
          //Show error popup
          console.log('Donation failed')
          this.setState({
            isProcessing: false,
            isFailed: true
          })
        }
      } catch (error) {
        console.error('Failed to execute donation', error)
        this.setState({
          isProcessing: false,
          isFailed: true
        })
      }
    }
  }

  fetchProjects = async () => {
    let projects, defaultProject = null, first

    if ((projects = this.props.campaignConfig.giftInfo?.customGiftDesignations)) {
      let firstProjectKey = Object.keys(projects)[0]
      first = [(projects[firstProjectKey])]
      delete projects[firstProjectKey]
    } else {
      defaultProject = await database().charityDatabase
        .child('config')
        .child('defaultProjectName')
        .orderByValue()
        .once('value')
        .then(value => value.val())

      projects = await database().charityDatabase
        .child('projects')
        .orderByValue()
        .once('value')
        .then(value => value.val())

      first = defaultProject ? [({ id: null, name: defaultProject })] : [({ id: undefined, name: 'Select An Option' })]
    }

    const rest = projects ? Object.keys(projects).map(projectId => !projects[projectId].hideProject ? ({ id: projectId, ...projects[projectId] }) : undefined).filter(value => !!value) : []

    this.setState({
      projects: first.concat(rest),
      selectedProject: first[0],
    })
  }

  initialize = async () => {
    getStore().dispatch({ type: DONATE_RESET })
    await this.fetchProjects()
    const parsed = queryString.parse(window.location.search)

    if (parsed.fromApp && window.sessionStorage) {
      try {
        window.sessionStorage.setItem('fromApp', 'true')
      } catch (e) {

      }
    }
    database()

    let authenticatedToken = null
    if (parsed.token) {
      let logInWithToken = this.props.userActions.logInWithToken
      const tokenPromise = new Promise((resolve) => {
        database().firebase.auth().onAuthStateChanged(user => {
          if (user) {
            console.log('Login with token executed.')
            resolve(parsed.token)
          } else {
            console.log('Auth changed but there\'s no user.')
          }
        })
      })
      logInWithToken(parsed.token)
      authenticatedToken = await tokenPromise
    } else {
      //Wait a bit to make sure auth goes through
      await timeout(2000)
      authenticatedToken = null
    }

    if (this.props.config.trackingId) {
      // Register that we started viewing the donation page.
      ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
        'step': 1
      })
      ReactGA.pageview(window.location.pathname + window.location.search)
    }

    this.setState({
      loaded: true
    })
  }

  handleDonationCompleted = () => {
    if (this.props.config.trackingId) {
      ReactGA.plugin.execute('ec', 'addProduct', {
        id: this.state.donationAmount.type === 'custom' ? 'donation-custom' : 'donation',
        name: 'Donation',
        variant: this.state.donationAmount.frequency || 'one-time',
        price: this.state.donationAmount.amount,
        quantity: 1
      })
      ReactGA.plugin.execute('ec', 'setAction', 'purchase', {
        id: new Date().getMilliseconds(),
        revenue: this.state.donationAmount.amount,
        tax: 0,
        shipping: 0
      })
      ReactGA.event({ category: 'Checkout', action: 'Donation Complete' })
    }
    if (this.props.config.stringValues.site.custom === 'BF') {
      FacebookTrackingPixel.loadPixel('PageView')
    }
  }

  componentDidMount() {
    saveUrlParams()
    if (this.props.config.customDonationUrl && window) {
      window.location.href = this.props.config.customDonationUrl
    }
    if (window) {
      window.scrollTo(0, 0)
    }
    this.initialize()
      .then(() => {
        console.info('Donate screen load complete.')
      })

    const urlParams = new URLSearchParams(window.location.search);
    const donorId = urlParams.get('donorId');
    const postId = urlParams.get('id');
    const segmentId = urlParams.get('segmentId');
    if (!isEmpty(trim(donorId)) && !isEmpty(trim(segmentId))) {
      addDonorToTrackingSegment(donorId, postId, segmentId)
    }

    const pid = urlParams.get('pid');
    if (!isEmpty(trim(pid)) && !isEmpty(trim(postId))) {
      trackMmsLinkClick(postId, pid)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.config.customDonationUrl && window) {
      window.location.href = this.props.config.customDonationUrl
    }
    if (this.state.isSuccess && !prevState.isSuccess) {
      Scroll.animateScroll.scrollToTop()
      this.handleDonationCompleted()
    }
  }

  render() {
    const Header = headerMapping[this.props.campaignConfig.header.type]
    const Sidebar = sidebarMapping[this.props.campaignConfig.sidebar.type]
    const GiftInfo = giftInfoMapping[this.props.campaignConfig.giftInfo.type]
    const DonorInfo = donorInfoMapping[this.props.campaignConfig.donorInfo.type]
    const PaymentInfo = paymentInfoMapping[this.props.campaignConfig.paymentInfo.type]

    const layout = {
      ...defaultLayout,
      ...this.props.campaignConfig.layout,
    }
    const sidebarSize = Sidebar ? layout.sidebarSize : 0
    const layoutStyles = {
      body: layout.maxWidth ? {
        maxWidth: `${layout.maxWidth}px`,
        marginLeft: 'auto',
        marginRight: 'auto'
      } : undefined,
      sidebar: {
        borderLeft: layout.sidebarStyle.border,
        marginTop: layout.sidebarStyle.marginTop
      },
      centerRow: {
        textAlign: 'center',
        marginTop: '10px'
      }
    }
    layoutStyles['sidebar'][`@media (max-width: ${layout.sidebarStyle.breakpoint - 1}px)`] = {
      display: 'none'
    }

    const saveInfo = this.state.saveInfo || (this.state.donationAmount && this.state.donationAmount.frequency === 'monthly')
    const saveInfoDisabled = this.state.donationAmount && this.state.donationAmount.frequency === 'monthly'

    return (

      <Fragment>
        {!this.props.config.disableGive &&
          <div className='donateV4'>
            {!this.state.isSuccess && <div>
              {Header && <div className='header'>
                <StyleRoot>
                  <Header assetLoader={this.props.assetLoader} {...this.props.campaignConfig.header} />
                </StyleRoot>
              </div>}
              <div style={[layoutStyles.body]}>
                <div
                  className={'donate-body' + ' col-md-' + (12 - sidebarSize) + ' col-xs-12'}>
                  <div className={'giftInfo'}>
                    <StyleRoot>
                      <GiftInfo onAmountChanged={this.updateAmount}
                        amount={this.state.donationAmount}
                        selectedProject={this.state.selectedProject}
                        projectMetadata={this.state.projectMetadata}
                        projects={this.state.projects}
                        onProjectChanged={this.updateProject}
                        onProjectMetadataChanged={this.updateProjectMetadata}
                        assetLoader={this.props.assetLoader}
                        displayErrors={this.state.displayErrors}
                        onValidChanged={this.giftValidChanged}
                        onChangeExtraFields={this.updateExtraFields}
                        onChangeExtraFieldsDependencies={this.updateExtraFieldsDependencies}
                        extraFieldsValues={this.state.extraFieldsValues}
                        extraFieldsDependencies={this.state.extraFieldsDependencies}
                        extraFieldsErrors={this.state.extraFieldsErrors}
                        defaultDependencies={this.defaultExtraFieldsValuesDependencies}
                        {...this.props.campaignConfig.giftInfo} />
                    </StyleRoot>
                  </div>
                  {this.state.loaded &&
                    <Fragment>
                      <div className={'donorInfo'}>
                        <StyleRoot>
                          <DonorInfo onInfoChanged={this.updateDonorInfo}
                            onValidChanged={this.donorInfoValidationChanged}
                            address={this.state.address}
                            onAddressChanged={this.updateAddress}
                            displayErrors={this.state.displayErrors}
                            values={this.state.basicDonorInfo}
                            cards={this.state.savedCards}
                            selectedCard={this.state.useExistingCard}
                            {...this.props.campaignConfig.donorInfo} />
                        </StyleRoot>
                      </div>
                      <div className={'paymentInfo'}>
                        <StyleRoot>
                          <PaymentInfo amount={this.state.donationAmount}
                            cards={this.state.savedCards}
                            selectedCard={this.state.useExistingCard}
                            onCardChanged={this.updateCard}
                            address={this.state.address}
                            onAddressChanged={this.updateAddress}
                            displayErrors={this.state.displayErrors}
                            validForm={this.allValid()}
                            canDonate={!this.state.displayErrors || this.allValid()}
                            onDonateClicked={this.execDonation}
                            assumeFee={this.state.assumeFee}
                            onAssumeFeeChanged={this.assumeFeeChanged}
                            saveInfo={saveInfo}
                            disableSaveInfo={saveInfoDisabled}
                            onSaveInfoChanged={this.saveInfoChanged}
                            onValidChanged={this.paymentValidChanged}
                            recaptchaSiteKey={this.props.config.recaptchaSiteKey}
                            validRecaptcha={this.state.recaptchaToken !== null}
                            isFailed={this.state.isFailed}
                            recaptchaChanged={this.recaptchaChanged}
                            assumeFeeLabel={ this.props.campaignConfig.paymentInfo?.customAssumeFeeLabel }
                            {...this.props.campaignConfig.paymentInfo}
                          />
                        </StyleRoot>
                      </div>
                    </Fragment>
                  }
                  {!this.state.loaded &&
                    <Row style={layoutStyles.centerRow}>
                      <Col xs={12}>
                        <Loader type='line-scale' active />
                        <br />
                      </Col>
                    </Row>
                  }
                </div>
                {Sidebar && <StyleRoot>
                  <div className={'sidebar' + ' col-md-' + sidebarSize}
                    style={[layoutStyles.sidebar]}>
                    <Sidebar assetLoader={this.props.assetLoader} {...this.props.campaignConfig.sidebar} />
                  </div>
                </StyleRoot>}
              </div>
              <ProcessingModal show={this.state.isProcessing} />
              <FailModal show={this.state.isFailed} onHide={this.closeFail} />
            </div>}
            {this.state.isSuccess &&
              <ThankYou hasApps={this.props.config.hasApps} />
            }
          </div>
        }
        {this.props.config.disableGive &&
          <NotFound />
        }
      </Fragment>

    )
  }
}

const DonatePageInjected = injectStripe(DonatePage)

export class DonateContainer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      stripe: null
    }
  }

  componentDidMount = async () => {
    const stripe = await loadStripe(this.props.stripeKey);
    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(this.props.stripeKey) })
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({ stripe: window.Stripe(this.props.stripeKey) })
      })
    }
  }

  render() {
    return (
      <StripeProvider stripe={this.state.stripe}>
        <Elements>
          <DonatePageInjected {...this.props} />
        </Elements>
      </StripeProvider>
    )
  }
}

export default withRouter(DonateContainer)
